import { ROUTES } from "@/constants";
import { PricingCardProps } from "@/components/screen/global-components/pricing/PricingCard";

export const pricingCards: PricingCardProps[] = [
  {
    iconId: "icon-standard-translation_58",
    title: "Standard Translation",
    priceLabel: "<span>$0.10</span>&nbsp;per word",
    description:
      "Our intelligent platform matches your project to an expert translator specialized in your language pair and use case. Get precision and accuracy across a variety of formats when you don’t require a certificate.",
    buttonPrimaryLabel: "Start order",
    buttonPrimaryHref: ROUTES.startOrder,
    buttonSecondaryLabel: "Learn more",
    buttonSecondaryHref: ROUTES.standardTranslation,
    features: [
      "Simple online ordering",
      "24-hour delivery",
      "Rigorous quality assurance",
      "Expert translators matched to your project needs",
      "24/7 support",
      "Unlimited free revisions",
    ],
  },
  {
    iconId: "icon-certified-translation_58",
    title: "Certified Translation",
    priceLabel: "<span>$24.50</span>&nbsp;per page",
    description:
      "Receive a word-for-word translation from an accredited translator, which comes with a dated, and signed certification statement as required by universities, courts, and government agencies. Express delivery, notarization, and mailed hard copies available.",
    buttonPrimaryLabel: "Start order",
    buttonPrimaryHref: ROUTES.startOrder,
    buttonSecondaryLabel: "Learn more",
    buttonSecondaryHref: ROUTES.certifiedTranslation,
    inheritsFrom: "Everything in Standard, plus:",
    features: [
      "Signed certification statement from ATA-certified translator",
      "Flexible delivery with notarized and two-day shipping available at checkout",
    ],
  },
];

export const enterpriseCard: PricingCardProps = {
  iconId: "icon-enterprise_58",
  title: "Enterprise",
  priceLabel: "Pricing on request",
  description:
    "Custom-fit our document translation services to your business. This fully managed offering empowers seamless order and delivery across any complexity or volume of translations.",
  buttonPrimaryLabel: "Get  a quote",
  buttonPrimaryHref: ROUTES.getQuote,
  buttonSecondaryLabel: "Learn more",
  buttonSecondaryHref: ROUTES.enterpriseTranslation,
  inheritsFrom: "Everything in Standard or Certified plus:",
  features: [
    "Dedicated project manager for personalized service",
    "Bulk ordering with volume-based cost savings",
    "Flexible billing and payment options",
    "White labeling and partner programs available",
    "Coming soon: API and CMS integration",
  ],
  isEnterprise: true,
};
